module.exports = __webpack_public_path__ + "static/media/fa-regular-400.935ae23b.woff2";